import classNames from 'classnames';
import Image from 'components/Image';
import styles from './LoadingIndicator.module.scss';

function LoadingIndicator({
  customCss = '',
  loadingMessage = 'Loading Products For You',
}) {
  return (
    <div className="mb-15 mb-md-30">
      <div
        className={classNames(
          'd-flex flex-column align-items-center justify-content-center',
          customCss
        )}
      >
        <div
          className={classNames(
            'position-relative h-100',
            styles.image_container
          )}
        >
          <Image
            fill
            legacy
            alt="loading"
            objectFit="contain"
            src="/firefly.gif"
          />
        </div>
        <div className="font-sofia fs-10 fs-md-16 text-primary">
          {loadingMessage}
        </div>
      </div>
    </div>
  );
}

export default LoadingIndicator;
